<template>
   <div class="uk-grid-medium uk-child-width-1-5@m uk-grid-small uk-grid-match tm-margin-large-top uk-text-center" data-uk-grid>
    <template v-for="one in modules" >
    <div :key="one.id" v-if="permissions[one.slug] == 1" >
           <a :href="one.url" target="_blank" class="uk-card uk-card-box uk-card-body uk-border-rounded">
               <span class="uk-icon-forder uk-border-rounded"><span :data-uk-icon="'icon: '+one.icon+'; ratio: 2'"></span></span>
               <p>{{one.title}}</p>
           </a>
     </div>
     </template>
   </div>
</template>

<script>
export default {
    props:['modules','permissions'],
}
</script>